module.exports = __webpack_public_path__ + "static/media/Empresas.d54e6ae5.svg";